import backend, {CLIENT_API, SCHEDULE_API, PAYMENT_API} from 'utils/backend/server/api_library';

import queryString from 'query-string';

const createClient = (input) => {
  const url = `${CLIENT_API}/client`;
  return backend.post(url, input);
};

const getClient = (clientRn, loadCareview, loadCareplan, loadForms, loadCallStatus, loadOwner) => {
  const queryParam = {
    loadCareview,
    loadCareplan,
    loadForms,
    loadCallStatus,
    loadOwner,
  };
  const query = queryString.stringify(queryParam, {skipNull: true, skipEmptyString: true});

  const url = `${CLIENT_API}/client/${clientRn}?${query}`;
  return backend.get(url);
};

const queryClient = (filters, sort, lastEvaluatedKey) => {
  const queryParam = {
    lastEvaluatedKey: lastEvaluatedKey,
  };
  if (filters) {
    queryParam.filters = JSON.stringify(filters);
  }
  if (sort) {
    queryParam.sort = JSON.stringify(sort);
  }

  const query = queryString.stringify(queryParam, {skipNull: true, skipEmptyString: true});
  const url = `${CLIENT_API}/client?${query}`;
  return backend.get(url);
};

const updateDescription = (clientRn, body) => {
  const url = `${CLIENT_API}/client/${clientRn}/detail/description`;
  return backend.put(url, body);
};

const updateFile = (clientRn, body) => {
  const url = `${CLIENT_API}/client/${clientRn}/detail/profile_image`;
  return backend.put(url, body);
};

const updateStatus = (clientRn, body) => {
  const url = `${CLIENT_API}/client/${clientRn}/detail/status`;
  return backend.put(url, body);
};

const updateName = (clientRn, body) => {
  const url = `${CLIENT_API}/client/${clientRn}/detail/name`;
  return backend.put(url, body);
};

const addContact = (clientRn, body) => {
  const url = `${CLIENT_API}/client/${clientRn}/detail/contact`;
  return backend.post(url, body);
};

const removeContact = (clientRn, body) => {
  const url = `${CLIENT_API}/client/${clientRn}/detail/contact`;
  return backend.delete(url, body);
};

const addCaregiver = (clientRn, body) => {
  const url = `${CLIENT_API}/client/${clientRn}/detail/caregiver`;
  return backend.post(url, body);
};

const removeCaregiver = (clientRn, body) => {
  const url = `${CLIENT_API}/client/${clientRn}/detail/caregiver`;
  return backend.delete(url, body);
};

const addRelationship = (clientRn, body) => {
  const url = `${CLIENT_API}/client/${clientRn}/detail/relationship`;
  return backend.post(url, body);
};

const editRelationship = (clientRn, relationshipRn, body) => {
  const url = `${CLIENT_API}/client/${clientRn}/detail/relationship/${relationshipRn}`;
  return backend.put(url, body);
};

const removeRelationship = (clientRn, relationshipRn) => {
  const url = `${CLIENT_API}/client/${clientRn}/detail/relationship/${relationshipRn}`;
  return backend.delete(url);
};

const createMessage = (clientRn, input) => {
  const url = `${CLIENT_API}/client/${clientRn}/message`;
  return backend.post(url, input);
};

const updateMessage = (clientRn, messageRn, input) => {
  const url = `${CLIENT_API}/client/${clientRn}/message/${messageRn}`;
  return backend.put(url, input);
};

const addEmoji = (clientRn, messageRn, input) => {
  const url = `${CLIENT_API}/client/${clientRn}/message/${messageRn}/emoji`;
  return backend.put(url, input);
};

const removeEmoji = (clientRn, messageRn, input) => {
  const url = `${CLIENT_API}/client/${clientRn}/message/${messageRn}/emoji`;
  return backend.delete(url, input);
};

const removeMessage = (clientRn, messageRn) => {
  const url = `${CLIENT_API}/client/${clientRn}/message/${messageRn}`;
  return backend.delete(url);
};

const loadMoreMessages = (clientRn, lastKey, loadSubmittedByData, loadEmojiRequesters) => {
  const queryParam = {
    lastEvaluatedKey: lastKey,
    loadSubmittedByData,
    loadEmojiRequesters,
  };

  const query = queryString.stringify(queryParam, {
    skipNull: true,
    skipEmptyString: true,
    encode: true,
  });

  return backend.get(`${CLIENT_API}/client/${clientRn}/message?${query}`);
};

const loadLogs = (clientRn, lastEvaluatedKey, loadRequesterData) => {
  const queryParam = {
    lastEvaluatedKey,
    loadRequesterData,
  };

  const query = queryString.stringify(queryParam, {
    skipNull: true,
    skipEmptyString: true,
    encode: true,
  });

  return backend.get(`${CLIENT_API}/client/${clientRn}/log?${query}`);
};

const loadScheduleByMonth = (clientRn, byMonth, loadCaregiverUpdates, loadCaregiverData, loadClientData) => {
  const body = {
    byMonth,
    loadCaregiverUpdates,
    loadCaregiverData,
    loadClientData,
  };

  return backend.post(`${SCHEDULE_API}/schedule/client/${clientRn}`, body);
};


const loadScheduleByIsoRange = (clientRn, isoRange, loadCaregiverUpdates, loadCaregiverData, loadClientData) => {
  const body = {
    isoRange,
    loadCaregiverUpdates,
    loadCaregiverData,
    loadClientData,
  };

  return backend.post(`${SCHEDULE_API}/schedule/client/${clientRn}`, body);
};

const addEvent = (clientRn, body) => {
  return backend.post(`${SCHEDULE_API}/schedule/client/${clientRn}/fixed`, body);
};

const deactivateEvent = (clientRn, eventRn, body) => {
  return backend.delete(`${SCHEDULE_API}/schedule/client/${clientRn}/fixed/${eventRn}`, body);
};

const addRecurrence = (clientRn, body) => {
  return backend.post(`${SCHEDULE_API}/schedule/client/${clientRn}/recurrence`, body);
};

const deactivateRecurrence = (clientRn, recurrenceRn, body) => {
  return backend.delete(`${SCHEDULE_API}/schedule/client/${clientRn}/recurrence/${recurrenceRn}`, body);
};

const cancelExceptionRecurrence = (clientRn, recurrenceRn, body) => {
  return backend.post(`${SCHEDULE_API}/schedule/client/${clientRn}/recurrence/${recurrenceRn}/exception/cancellation`, body);
};

const careviewAddQuestion = (clientRn, type, questionData) => {
  const body = {
    type,
    questionData,
  };

  return backend.post(`${CLIENT_API}/client/${clientRn}/careview/question`, body);
};

const careviewUpdateQuestion = (clientRn, questionRn, questionData) => {
  const body = {
    questionData,
  };

  return backend.put(`${CLIENT_API}/client/${clientRn}/careview/question/${questionRn}`, body);
};

const careviewDeleteQuestion = (clientRn, questionRn) => {
  return backend.delete(`${CLIENT_API}/client/${clientRn}/careview/question/${questionRn}`);
};

const careviewReorderQuestion = (clientRn, reorderList) => {
  const body = {
    reorderList,
  };
  return backend.post(`${CLIENT_API}/client/${clientRn}/careview/question/reorder`, body);
};

const careviewResetQuestions = (clientRn) => {
  return backend.post(`${CLIENT_API}/client/${clientRn}/careview/question/reset`);
};

const cancelEvent = (clientRn, eventRn, reasonForException) => {
  const body = {
    reasonForException,
  };
  const url = `${SCHEDULE_API}/schedule/client/${clientRn}/event/${eventRn}/cancel`;
  return backend.put(url, body);
};

const rescheduleEvent = (clientRn, eventRn, reasonForException, eventData) => {
  const body = {
    reasonForException,
    eventData,
  };
  const url = `${SCHEDULE_API}/schedule/client/${clientRn}/event/${eventRn}/reschedule`;
  return backend.put(url, body);
};


const loadClientPaymentPlan = (clientRn) => {
  const url = `${PAYMENT_API}/payment/plan/client/${clientRn}`;
  return backend.get(url);
};

const startForm = (clientRn, formKey, body) => {
  const url = `${CLIENT_API}/client/${clientRn}/forms/${formKey}/start`;
  return backend.post(url, body);
};

const generateCareplan = (clientRn) => {
  const url = `${CLIENT_API}/client/${clientRn}/forms/generate_care_plan`;
  return backend.post(url);
};

export default {
  createClient,
  getClient,
  queryClient,

  updateDescription,
  updateStatus,
  updateFile,
  updateName,
  addContact,
  removeContact,
  addCaregiver,
  removeCaregiver,

  loadClientPaymentPlan,

  relationship: {
    add: addRelationship,
    edit: editRelationship,
    remove: removeRelationship,
  },

  message: {
    create: createMessage,
    update: updateMessage,
    delete: removeMessage,
    load: loadMoreMessages,

    emoji: {
      add: addEmoji,
      remove: removeEmoji,
    },
  },

  loadLogs,

  schedule: {
    loadByMonth: loadScheduleByMonth,
    loadByIsoRange: loadScheduleByIsoRange,
    addEvent,
    deactivateEvent,
    addRecurrence,
    deactivateRecurrence,
    cancelExceptionRecurrence,
    cancelEvent,
    rescheduleEvent,
  },

  careview: {
    addQuestion: careviewAddQuestion,
    updateQuestion: careviewUpdateQuestion,
    deleteQuestion: careviewDeleteQuestion,
    reorderQuestion: careviewReorderQuestion,
    resetQuestions: careviewResetQuestions,
  },

  intakeForm: {
    startForm,
    generateCareplan,
  },
};
